import { Stack } from '@mui/material';
import type { ReactNode } from 'react';

export interface AuthCardProps {
  children: ReactNode;
  /** A footer link/action, e.g. "Already have an account? Sign in". */
  footer?: ReactNode;
}

/** Consistent internal spacing for every screen rendered inside `AuthLayout`'s card — the layout
 * owns the outer `Card`/brand heading; this owns the per-screen body/footer rhythm. */
export function AuthCard({ children, footer }: AuthCardProps) {
  return (
    <Stack spacing={2.5}>
      {children}
      {footer ? <Stack sx={{ textAlign: 'center' }}>{footer}</Stack> : null}
    </Stack>
  );
}
